// extracted by mini-css-extract-plugin
export default {"container":"VoiceRecorderModal_container__5TlZ6","recorderContainer":"VoiceRecorderModal_recorderContainer__xYuxj"};